module.exports = __webpack_public_path__ + "static/media/Intersection 19.070a774f.png";